// src/api/axiosInstance.js
import axios from "axios";
import * as Sentry from "@sentry/react";

const axiosInstance = axios.create({
  timeout: 15000,
});

// ─── Request Interceptor ───────────────────────────────────────────
axiosInstance.interceptors.request.use(
  (config) => {
    Sentry.addBreadcrumb({
      category: "http.request",
      message: `${config.method?.toUpperCase()} ${config.url}`,
      data: {
        url: config.url,
        method: config.method,
        params: config.params,
      },
      level: "info",
    });
    return config;
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

// ─── Response Interceptor ──────────────────────────────────────────
axiosInstance.interceptors.response.use(
  (response) => {
    Sentry.addBreadcrumb({
      category: "http.response",
      message: `${response.status} ${response.config?.url}`,
      data: {
        status: response.status,
        url: response.config?.url,
      },
      level: "info",
    });
    return response;
  },
  (error) => {
    const { response, config } = error;

    Sentry.withScope((scope) => {
      scope.setTag("api.url", config?.url);
      scope.setTag("api.method", config?.method);
      scope.setTag("api.status", response?.status);
      scope.setContext("API Error", {
        url: config?.url,
        method: config?.method,
        status: response?.status,
        responseData: response?.data,
        requestParams: config?.params,
      });

      if (response?.status >= 500) scope.setLevel("error");
      else if (response?.status >= 400) scope.setLevel("warning");

      Sentry.captureException(error);
    });

    return Promise.reject(error);
  }
);

export default axiosInstance;   // ✅ must be default export